export default __webpack_public_path__ + "static/media/Group 3.4a991bb8.svg";